/**
 * Return `_blank` if href is an external link
 * @function
 * @param {} href
 * @returns {}
 */
export const makeLinkTarget = (href: string) => {
	if (!href.startsWith("http")) return;

	return "_blank" as const;
};
